<div class="static-page-layout">
  <div class="static-page-content">
    <main class="term-condition">
      <h5 class="term-condition__header">TERMS AND CONDITIONS</h5>

      <p>
        These terms and conditions (the “Terms and Conditions”) govern the use
        of
        <a href="https://www.easyvta.com/">www.easyvta.com</a> (the “Site”).
        This Site is owned and operated by A2J Software Ltd.. This Site is a
        time-off tracking web application.
      </p>

      <br />

      <p>
        By using this Site, you indicate that you have read and understand these
        Terms and Conditions and agree to abide by them at all times.
      </p>

      <br />

      <section class="section">
        <h6 class="section__header">Intellectual Property</h6>

        <p>
          All content published and made available on our Site is the property
          of A2J Software Ltd. And the Site's creators. This includes, but is
          not limited to images, text, logos, documents, downloadable files and
          anything that contributes to the composition of our Site.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Accounts</h6>

        <p>
          When you create an account on our Site, you agree to the following:
        </p>

        <ol>
          <li>
            You are solely responsible for your account and the security and
            privacy of your account, including passwords or sensitive
            information attached to the account; and
          </li>
          <li>
            All personal information you provide to us through your account is
            up to date, accurate, and truthful and that you will update your
            personal information if it changes.
          </li>
        </ol>

        <p>
          We reserve the right to suspend or terminate your account if you are
          using our Site illegally or if you violate these Terms and Conditions.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Limitation of Liability</h6>
        <p>
          A2J Software Ltd. and our directors, officers, agents, employees,
          subsidiaries, and affiliates will not be liable for any actions,
          claims, losses, damages, liabilities and expenses including legal fees
          from your use of the Site.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Indemnity</h6>
        <p>
          Except where prohibited by law, by using this Site you indemnify and
          hold harmless A2J Software Ltd. And our directors, officers, agents,
          employees, subsidiaries, and affiliates from any actions, claims,
          losses, damages, liabilities and expenses including legal fees arising
          out of your use of our Site or your violation of these Terms and
          Conditions.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Applicable Law</h6>
        <p>
          These Terms and Conditions are governed by the laws of the Province of
          Ontario.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Severability</h6>
        <p>
          If at any time any of the provisions set forth in these Terms and
          Conditions are found to be inconsistent or invalid under applicable
          laws, those provisions will be deemed void and will be removed from
          these Terms and Conditions. All other provisions will not be affected
          by the removal and the rest of these Terms and Conditions will still
          be considered valid.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Changes</h6>
        <p>
          These Terms and Conditions may be amended from time to time in order
          to maintain compliance with the law and to reflect any changes to the
          way we operate our Site and the way we expect users to behave on our
          Site. We will notify users by email of changes to these Terms and
          Conditions or post a notice on our Site.
        </p>
      </section>

      <section class="section">
        <h6 class="section__header">Contact Details</h6>
        <p>
          Please contact us if you have any questions or concerns. Our contact
          details are
          <a href="mailto:contact@easyvta.com">contact&#64;easyvta.com</a>
        </p>
      </section>

      <br />

      <p>Effective Date: 1<sup>st</sup> day of April, 2026</p>
    </main>
  </div>
</div>